export type JSONAtom = string | number | boolean | null
export type JSONList = JSONValue[]
export type JSONObject = {[prop: string]: JSONValue | undefined}
export type JSONValue = JSONAtom | JSONList | JSONObject
